<!-- <div [ngClass]="{'cursor-help':el.scrollWidth > el.clientWidth && showHelpCursor}" #el
    matTooltip="{{selectedUnit?.unitName}}" matTooltipClass="overflow-wrap"
    [matTooltipDisabled]="!(el.scrollWidth > el.clientWidth)">
<ng-content></ng-content>
</div> -->

<div
  #el
  class="ws-collapse"
  [ngClass]="{
    'overflow-ellipsis': true,
    'cursor-help': el.scrollWidth > el.clientWidth && showHelpCursor
  }"
  matTooltip="{{ el.innerHTML }}"
  [matTooltipDisabled]="!(el.scrollWidth > el.clientWidth)"
>
  <ng-content></ng-content>
</div>
